import React from 'react';
import { Card, Typography, Box } from '@mui/material';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';

/**
 * What a parent sees while re-enrolment is closed, in place of the login form. The message is the
 * one set in the staff Settings screen. AR staff still sign in at /arlogin, and the allowed parents
 * at /?login=ghost.
 */
const ClosedNotice = ({ message }) => (
    <Card
        elevation={0}
        sx={{ p: { xs: 3, sm: 5 }, textAlign: 'center', borderRadius: '16px', border: '1px solid #e2e8f0', maxWidth: 520, mx: 'auto' }}
    >
        <EventAvailableOutlinedIcon sx={{ fontSize: 56, color: '#059669', mb: 2 }} />
        <Typography variant="h5" sx={{ fontWeight: 700, color: '#0f172a', mb: 1.5 }}>
            Re-enrolment is opening soon
        </Typography>
        <Typography sx={{ color: '#475569', whiteSpace: 'pre-line' }}>{message}</Typography>
        <Box sx={{ mt: 3 }}>
            <Typography sx={{ fontSize: '13px', color: '#64748b' }}>
                Questions? Contact College Support at{' '}
                <a href="tel:+61893622100" style={{ color: '#059669', fontWeight: 600, textDecoration: 'none' }}>
                    (08) 9362 2100
                </a>
            </Typography>
        </Box>
    </Card>
);

export default ClosedNotice;
